import { AfterViewInit, Component, ElementRef, OnInit, signal, viewChild, inject } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { RequestBuilderService } from '../../../../shared/services/request-builder.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { EnvConfigService } from '../../../../shared/services/env-config.service';

@Component({
  selector: 'app-messaging-dialog',
  standalone: true,
  imports: [ButtonComponent],
  templateUrl: './messaging-dialog.component.html',
  styleUrl: './messaging-dialog.component.scss',
})
export class MessagingDialogComponent implements OnInit, AfterViewInit {
  ref = inject(DynamicDialogRef);
  config = inject(DynamicDialogConfig);
  private readonly sanitizer = inject(DomSanitizer);
  private readonly requestBuilder = inject(RequestBuilderService);
  private readonly env = inject(EnvConfigService);

  loading = signal<boolean>(true);
  adroitIframeUrl = signal<SafeResourceUrl>('');
  readonly iframe = viewChild.required<ElementRef<HTMLIFrameElement>>('iframe');

  ngOnInit() {
    this.sanitizeAdroitUrl();
  }

  ngAfterViewInit() {
    const observer = new ResizeObserver(() => {
      const iframe = this.iframe();
      if (iframe.nativeElement) {
        const height = iframe.nativeElement.contentWindow?.document.body.scrollHeight;
        iframe.nativeElement.style.height = `${height}px`;
      }
    });

    observer.observe(this.iframe().nativeElement);
  }

  sanitizeAdroitUrl() {
    const determineUrlPrefix = () => {
      const { field, allMessages, rideId } = this.config.data;

      if (field === 'guardian') {
        if (allMessages) {
          return `${this.env.getConfig().adrAdminUrl}/messaging/guardians?`;
        } else {
          return `${this.env.getConfig().adrAdminUrl}/messaging/ride-guardians?rideId=${rideId}&`;
        }
      } else if (field === 'contractor') {
        if (allMessages) {
          return `${this.env.getConfig().adrAdminUrl}/messaging/contractors?`;
        } else {
          return `${this.env.getConfig().adrAdminUrl}/messaging/ride-contractors?rideId=${rideId}&`;
        }
      } else {
        return '';
      }
    };

    this.requestBuilder.get(`configurations/AdroitApiKey`).subscribe({
      next: res => {
        const urlPrefix = determineUrlPrefix();
        const encodedApiKey = encodeURIComponent(res.data.propertyValue as string);
        this.adroitIframeUrl.set(this.sanitizer.bypassSecurityTrustResourceUrl(`${urlPrefix}api_key=${encodedApiKey}`));
      },
      error: err => {},
    });
  }
}
